import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './SettingsPages.css';
import './HelpCenterSettings.css';

function HelpCenterSettings() {
  const { t } = useTranslation('profile');

  const [openFaqIndex, setOpenFaqIndex] = useState(null);

  const handleContact = () => {
    // TODO: Otwórz formularz kontaktu
    alert(t('profile.settings.pages.help.contactAlert'));
  };

  const toggleFaq = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  const faqItems = [
    'howCreateEvent',
    'howJoinEvent',
    'howViewProfile',
    'cannotAttendEvent',
    'howFriendsWork',
    'canEditEvent',
    'howNotificationsWork',
    'whatIsLastSeen',
  ];

  return (
    <div className="settings-page">
      <div className="settings-page-content">
        {/* Szybka pomoc */}
        <div className="help-center-section">
          <h3 className="help-center-section-title">
            {t('profile.settings.pages.help.quickHelp')}
          </h3>

          <div className="help-center-contact-item">
            <div className="help-center-contact-content">
              <div className="help-center-contact-label">
                {t('profile.settings.pages.help.contactUs')}
              </div>
              <div className="help-center-contact-description">
                {t('profile.settings.pages.help.contactUsDescription')}
              </div>
            </div>
            <button
              className="help-center-button"
              onClick={handleContact}
            >
              {t('profile.settings.pages.help.contact')}
            </button>
          </div>
        </div>

        {/* Często zadawane pytania */}
        <div className="help-center-section">
          <h3 className="help-center-section-title">
            {t('profile.settings.pages.help.faqTitle')}
          </h3>

          <div className="help-center-faq-list">
            {faqItems.map((faqKey, index) => (
              <div
                key={faqKey}
                className={`help-center-faq-item ${openFaqIndex === index ? 'open' : ''}`}
              >
                <button
                  className="help-center-faq-question"
                  onClick={() => toggleFaq(index)}
                >
                  <span className="help-center-faq-question-text">
                    {t(`profile.settings.pages.help.faq.${faqKey}.question`)}
                  </span>
                  <span className="help-center-faq-icon">
                    {openFaqIndex === index ? '−' : '+'}
                  </span>
                </button>
                {openFaqIndex === index && (
                  <div className="help-center-faq-answer">
                    {t(`profile.settings.pages.help.faq.${faqKey}.answer`)}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelpCenterSettings;
